export type HighAlert = {
  id: string;
  programId: string;
  programName: string;
  window: HighAlertWindow;
  createdByName: string;
  createdById: string;
  createdDate: string | Date;
  startDate: string | Date;
  endDate: string | Date;
  notes: string;
  status: string;
  timezone: string;
  updatedDate: string | Date;
  updatedBy: string;
  isUserTheOwner?: boolean;
};

export type HighAlertPost = {
  program_id: string;
  notes: string;
  window: string;
  start_dttm: string | Date;
  end_dttm: string | Date;
  timezone: string;
  created_by: string;
  created_dttm: string;
};

export enum HighAlertWindow {
  HIGH_ALERT = 'HIGH_ALERT',
  ELEVATED = 'ELEVATED',
  AUDIT = 'AUDIT',
  HOT_WEATHER = 'HOT_WEATHER',
  COLD_WEATHER = 'COLD_WEATHER',
}

export enum HighAlertStatus {
  CURRENT = 'Current',
  PAST = 'Past',
}

export type HighAlertDto = {
  id: number;
  program_id: string;
  notes: string;
  start_dttm: string;
  end_dttm: string;
  window: string;
  // alert_type: string;
  // actions: string;
  created_by: string;
  updated_by: string;
  created_dttm: string;
  updated_dttm: string;
  status: string;
  timezone: string;
};

export type HighAlertPut = HighAlertDto;
